import { render } from "./test.vue?vue&type=template&id=35dae02e&scoped=true&ts=true"
import script from "./test.vue?vue&type=script&lang=ts"
export * from "./test.vue?vue&type=script&lang=ts"

import "./test.vue?vue&type=style&index=0&id=35dae02e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35dae02e"]])

export default __exports__